import { render, staticRenderFns } from "./FashionList.vue?vue&type=template&id=89ab1468&"
import script from "./FashionList.vue?vue&type=script&lang=js&"
export * from "./FashionList.vue?vue&type=script&lang=js&"
import style0 from "./FashionList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports